// URL-building helpers shared by the multi-file upload (S9/S11/S23 — HU-03/HU-07) and the
// thumbnail reorder (S21 — HU-06) of DocumentsCarouselView. Mirrors the persisted-vs-temp
// pattern already used by Document.jsx's create/edit actions, extracted so both call sites stay
// consistent and testable without mounting the whole component.

/**
 * @param {{resourceType: string, referenceId: (string|number), referenceTempUUID: string, referenceUUID: string}} params
 * @returns {string}
 */
const buildDocumentCreateUrl = ({ resourceType, referenceId, referenceTempUUID, referenceUUID }) => {
  if (referenceTempUUID) {
    return 'document/createTemp/' + resourceType + '/' + referenceTempUUID + '/' + referenceUUID
  }
  return 'document/create/' + resourceType + '/' + referenceId
}

/**
 * @param {{referenceTempUUID: string, referenceUUID: string}} params
 * @returns {string}
 */
const buildDocumentUpdateUrl = ({ referenceTempUUID, referenceUUID }) => {
  if (referenceTempUUID) {
    return 'document/updateTemp/' + referenceTempUUID + '/' + referenceUUID
  }
  return 'document/update'
}

export { buildDocumentCreateUrl, buildDocumentUpdateUrl }
